import axios from 'axios';
import * as AppConstant from '../../Components/AppConstant';

const instance = axios.create({
    baseURL: AppConstant.API_URL
});

// Add a request interceptor
instance.interceptors.request.use(config => {
    // console.log(config);
    // Insert authorization token on request call
    // const jwt_token = AppConstant.JWT_TOKEN;//localStorage.getItem('auth_token');
    // if( jwt_token ) config.headers['Authorization'] = 'Bearer '+jwt_token;
    // UPDATE: Add this code to show global loading indicator
    if(config.hideLoader && config.hideLoader===true){

    } else {
        document.body.classList.add('loading-indicator');
    }    
    return config;
}, error => {
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(response => {
    // UPDATE: Add this code to hide global loading indicator
    document.body.classList.remove('loading-indicator');
    return response;
}, error => {
    document.body.classList.remove('loading-indicator');
    return Promise.reject(error.response);
});

export default instance;